import { Button, TextField } from "components";
import { useExemptionsContext } from "../../ExemptionsContext";
import { useEventTracker } from "utils/useEventTracker";
import constants from "utils/constants";
import { usePropertyContext } from "../../context";
import ButtonV2 from "elements/ButtonV2";

const SqFt = () => {
	const { next, sqFtIncomeProducing, setSqFtIncomeProducing } =
		useExemptionsContext();
	const { details } = usePropertyContext();
	const trackEvent = useEventTracker();

	const handleSubmit = async () => {
		if (sqFtIncomeProducing && sqFtIncomeProducing > 100) {
			setSqFtIncomeProducing(100);
		}
		trackEvent({
			eventName: constants.EVENTS.Exemptions_Flow_Income_Producting_Answer,
			data: {
				"% Income Producing":
					sqFtIncomeProducing && sqFtIncomeProducing > 100
						? 100
						: sqFtIncomeProducing,
				"Is End-To-End Signup": details?.exemption?.is_end_to_end_signup
					? "Yes"
					: "No",
			},
		});
		const trackingEventData = {
			"% Income Producing":
				sqFtIncomeProducing && sqFtIncomeProducing > 100
					? 100
					: sqFtIncomeProducing,
		};
		next({ trackingEventData });
	};

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				handleSubmit();
			}}>
			<div className="property-profile-question-card exemption-survey-card">
				<div className="property-profile-question-card-title-container exemption-survey-question-income-producing">
					<p>What percentage of the property is incoming producing?</p>
				</div>
				<TextField
					required
					label="% of sqft"
					placeholder="% of SQFT"
					type="number"
					maxLength={3}
					containerClassName="exemptions-card-input"
					value={sqFtIncomeProducing === 0 ? "" : sqFtIncomeProducing ?? ""}
					onChange={e => {
						if (e.target.value.length <= 3) {
							setSqFtIncomeProducing(parseInt(e.target.value) || 0);
						}
					}}
				/>
			</div>
			<ButtonV2
				size="large"
				disabled={sqFtIncomeProducing === undefined}
				type="submit">
				Continue
			</ButtonV2>
		</form>
	);
};

export default SqFt;
